

// import sequnce from './modules/sequnce';
import changeVideo from './modules/changeVideo';
import swiper from './modules/swiper';
import audio from './modules/audio';
import accordion from './modules/accordion';
import microAnimations from './modules/microAnimations';
import render from './modules/renderData';
import audioObserver from './modules/audioObserver';
import  validate  from './modules/validate';
import send from './modules/send';
window.addEventListener('DOMContentLoaded', () => {
	window.scrollTo(0,0);
	console.log('scroll-to')
	// sequnce();
	validate();
	send();
	render();
	audio();
	const sw = swiper();
	audioObserver(sw);
	accordion();
	changeVideo();
	microAnimations();
});

